// tslint:disable

import * as React from 'react';
import { FileManager } from '../../components/structurals/file-manager/file-manager';

export class MediaManager extends React.Component<any, any> {
    render() {
        return <FileManager
            onChanges$={this.props.ON_CHANGE$}
            onSelectSuccessful={this.props.CONFIG.onSelectSuccessful}
            defaultSelected={this.props.CONFIG.defaultSelected}
            multi={this.props.CONFIG.multi === undefined ? true : this.props.CONFIG.multi}/>
    }
}



// WEBPACK FOOTER //
// ./src/__templates/libs/media-manager.tsx